module.exports = __webpack_public_path__ + "img/icon-arrow-3.708301e8.svg";